/**
 * Bubble 需要受控显示, 但也是hover的交互感觉
 */
import React, {useEffect, useRef, useState} from 'react';
import {useIntl} from 'umi';
import {Bubble, BubbleProps} from "tea-component";
import {LANGUAGE_EN} from "@home/_config/config";

const CustomHoverBubble = (props: BubbleProps & { referenceElement: Element | null;}) => {
  const { children, visible, referenceElement, ...rest } = props;
  const { locale} = useIntl();
  const isEn = locale === LANGUAGE_EN;
  // 定时器
  const timeoutRef = React.useRef<number | null>(null);
  // 记录鼠标是否划入气泡内部
  const isMouseEnterBubbleRef = useRef<boolean>(false);
  const [visibleScope, setVisibleScope] = useState(false);
  
  // 使用 requestAnimationFrame 确保在下一帧执行
  useEffect(() => {
    let ele: Element | null | undefined = undefined;
    const onLeave = () => {
      // 当鼠标滑入气泡内部时, 不执行leave事件
      if (isMouseEnterBubbleRef.current) return;
      timeoutRef.current = window.setTimeout(() => {
        setVisibleScope(false);
      }, 300);
    };
    const onEnter = () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
      setVisibleScope(true);
    };
    
    const rafId = requestAnimationFrame(() => {
      // 这个ele 需要在requestAnimationFrame中获取, 才能保证每次都能添加事件成功, 否则有些情况下即便获取到了ele也无法添加成功
      ele = referenceElement;
      if (ele) {
        ele.addEventListener('mouseleave', onLeave);
        ele.addEventListener('mouseenter', onEnter);
      }
    });
    
    return () => {
      cancelAnimationFrame(rafId);
      // 清理事件监听器
      if (ele) {
        ele.removeEventListener('mouseleave', onLeave);
        ele.removeEventListener('mouseenter', onEnter);
      }
    };
  }, [isEn, referenceElement]);
  
  return (
    <Bubble
      visible={visible && visibleScope}
      dark
      placement={"bottom"}
      flipped={false}
      escapeWithReference={true}
      referenceElement={referenceElement}
          
      onMouseEnter={() => {
        isMouseEnterBubbleRef.current = true;
        // 鼠标滑入时 取消 之前定时关闭气泡的setTimeout
        timeoutRef.current && clearTimeout(timeoutRef.current);
        setVisibleScope(true);
      }}
      onMouseLeave={() => {
        isMouseEnterBubbleRef.current = false;
        timeoutRef.current = window.setTimeout(() => {
          setVisibleScope(false);
        }, 300);
      }}
      {...rest}
    >
      {children}
    </Bubble>
  );
};

const CustomHoverBubbleWrap = (props: BubbleProps & { referenceElement: Element | null; hiddenBubble?: boolean; }) => {
  if (props?.hiddenBubble) return (<>{props.children}</>);
  return <CustomHoverBubble {...props}/>;
  
};

export default CustomHoverBubbleWrap;